import React from "react";

const EmptyData = () => {
    return (
        <div className="text-center">
            <img
                srcSet="/images/emptyData.png"
                className="inline-block"
                alt="fafu-emptydata"
            />
            <div className="mx-auto mt-0 text-xl font-bold leading-9">
                Không có dữ liệu
            </div>
        </div>
    );
};

export default EmptyData;
